import axios from 'axios'
import { config, url } from '@/store'
import usersApi from '@/api/usersApi'
import { currentDateTime, debounce } from '@/utils/utils'
import moment from 'moment'
import approveApi from '@/api/approveApi'
import router from '@/router'
import { ApproveApi } from '@/api/approve'
import { vuexFileBase } from '@/store/compositionV2/utils/file'
import { showAlertError, showAlertWarning } from '@/utils/store/alert'

const initialState = () => {
  return {
    approve: {
      name: '',
      activity: true,
      expiration_date: moment().format('YYYY-MM-DD 12:00'),
      in_order: false,
      document: {
        name: 'Не выбрано',
        id: null
      },
      files: [],
      comment: '',
      oldComment: '',
      comments: [],
      updatedComments: [],
      deletedComments: [],
      controls: [],
      modalControl: {
        updatedId: null,
        active: false,
        value: { id: null, name: 'Не выбрано' }
      },
      tableControlsHeader: {
        allActive: false,
        headers: [
          {
            title: 'ФИО',
            isSortable: false
          }
        ]
      },
      isActiveDeleteControls: false,
      deletedControls: [],
      responsibles: [],
      modalResponsible: {
        updatedId: null,
        active: false,
        value: { id: null, name: 'Не выбрано' },
        order: { id: null, name: 'Не выбрано' }
      },
      tableResponsiblesHeader: {
        allActive: false,
        headers: [
          {
            title: 'ФИО',
            isSortable: false
          },
          {
            title: 'Проголосовал',
            isSortable: false
          },
          {
            title: 'Решение',
            isSortable: false
          },
          {
            title: 'Дата голосования',
            isSortable: false
          }
        ]
      },
      isActiveDeleteResponsibles: false,
      deletedResponsibles: [],
      createBy: ''
    },
    controlsOptions: [],
    treaties: [],
    orderOptions: [{ id: 1, name: '1' }, { id: 2, name: '2' }, { id: 3, name: '3' }, { id: 4, name: '4' }, { id: 5, name: '5' }, { id: 6, name: '6' }, { id: 7, name: '7' }, { id: 8, name: '8' }, { id: 9, name: '9' }, { id: 10, name: '10' }, { id: 11, name: '11' }, { id: 12, name: '12' }, { id: 13, name: '13' }, { id: 14, name: '14' }, { id: 15, name: '15' }, { id: 16, name: '16' }, { id: 17, name: '17' }, { id: 18, name: '18' }, { id: 19, name: '19' }, { id: 20, name: '20' }],
    validation: {
      name: { type: null, message: '' },
      date: { type: null, message: '' },
      control: { type: null, message: '' },
      responsible: { type: null, message: '' }
    },
    isLoading: true,
    isDisabling: false,
    canEditing: true,
    vote: {
      canVote: false,
      voted: false
    },
    debounce: null,
    api: ApproveApi,
    ...vuexFileBase.createState()
  }
}

const state = initialState

const getters = {
  '[approve] getItemForUpdate': state => state.approve,
  '[approve] getItemUpdateTreaties': state => state.treaties,
  '[approve] getItemUpdateControlsOptions': state => state.controlsOptions,
  '[approve] getItemUpdateOrderOptions': state => state.orderOptions,
  '[approve] getItemUpdateControls': state => state.approve.controls,
  '[approve] getItemUpdateResponsibles': state => state.approve.responsibles,
  '[approve] getItemUpdateValidation': state => state.validation,
  '[approve] getItemUpdateIsLoading': state => state.isLoading,
  '[approve] getItemUpdateIsDisabling': state => state.isDisabling,
  '[approve] getItemUpdateCanVote': state => state.vote,
  '[approve] getItemUpdateCanEdit': state => state.canEditing
}

const mutations = {
  ...vuexFileBase.createMutations(),
  '[approve] SET_DEBOUNCE': (state, debounce) => {
    state.debounce = debounce
  },
  '[approve] SET_INITIAL_STATE': (state) => {
    Object.assign(state, initialState())
  },

  '[approve] GET_ITEM_UPDATE': (state, [approve, id]) => {
    state.vote.canVote = false
    state.vote.voted = false

    const sApprove = state.approve

    sApprove.id = approve.id
    sApprove.name = approve.name
    sApprove.expiration_date = approve.expiration_date
    sApprove.createBy = approve.user.profile.full_name
    sApprove.document = approve.treaty !== null ? { name: `${approve.treaty.id} - ${approve.treaty.partner.long_name}, [project_name]`, id: approve.treaty.id } : { name: 'Не выбрано', id: null }
    sApprove.in_order = approve.in_order
    sApprove.activity = approve.activity

    if (approve.in_order) {
      sApprove.tableResponsiblesHeader.headers = [
        {
          title: 'ФИО',
          isSortable: false
        },
        {
          title: 'Порядок',
          isSortable: false
        },
        {
          title: 'Проголосовал',
          isSortable: false
        },
        {
          title: 'Решение',
          isSortable: false
        },
        {
          title: 'Дата голосования',
          isSortable: false
        }
      ]
    } else {
      sApprove.tableResponsiblesHeader.headers = [
        {
          title: 'ФИО',
          isSortable: false
        },
        {
          title: 'Проголосовал',
          isSortable: false
        },
        {
          title: 'Решение',
          isSortable: false
        },
        {
          title: 'Дата голосования',
          isSortable: false
        }
      ]
    }

    state.isDisabling = true
    state.isLoading = false

    state.canEditing = approve.user_id === id || approve.controls?.some(item => item.user?.id === id)

    sApprove.controls = approve.controls ? approve.controls.map(e => {
      return {
        id: e.id,
        isActive: false,
        value: {
          id: e.user.id,
          name: e.user.profile.full_name
        }
      }
    }) : []
    sApprove.responsibles = approve.responsibles ? approve.responsibles.map(e => {
      state.orderOptions.slice(state.orderOptions.indexOf(e.sort), 1)
      return {
        id: e.id,
        isActive: false,
        value: {
          id: e.user.id,
          name: e.user.profile.full_name,
          decision: e.decision,
          voted: e.voted,
          voting_date: e.voting_date ? e.voting_date : 'Нет',
          sort: e.sort
        }
      }
    }) : []

    sApprove.comments = approve.comments ? approve.comments.map(e => {
      return {
        value: e.text,
        name: e.user.profile.full_name,
        position: e.user?.position?.name,
        created_at: e.created_at,
        id: e.id,
        isControlsActive: false,
        user_id: e.user_id
      }
    }) : []

    sApprove.files = approve.files ? approve.files.map(e => {
      return {
        name: e.file_name,
        size: e.file_size,
        url: e.url,
        type: e.content_type,
        id: e.id
      }
    }) : []

    if (sApprove.in_order) {
      let nowVote = {
        value: {
          sort: 20
        }
      }
      sApprove.responsibles.forEach(e => {
        console.log(e.value.sort, nowVote.value.sort)
        if ((e.value.sort < nowVote.value.sort) && !e.value.voted) {
          nowVote = e
        }
      })
      if (nowVote.value.id === id) {
        if (nowVote.value.voted) {
          state.vote.canVote = false
          state.vote.voted = true
        } else {
          state.vote.canVote = true
        }
      }
      console.log(nowVote)
    } else {
      sApprove.responsibles.forEach(e => {
        if (e.value.id === id && !e.value.voted) {
          state.vote.canVote = true
        } else if (e.value.id === id && e.value.voted) {
          state.vote.canVote = false
          state.vote.voted = true
        }
      })
    }

    const usedOrders = []
    sApprove.responsibles.forEach(e => {
      usedOrders.push(e.value.sort)
    })

    const diff = function (a1, a2) {
      return a1.filter(i => !a2.includes(i.id))
    }

    state.orderOptions = diff(state.orderOptions, usedOrders)
  },

  '[approve] SET_ITEM_UPDATE_NAME': (state, value) => {
    state.approve.name = value
  },
  '[approve] SET_ITEM_UPDATE_ACTIVITY': (state) => {
    state.approve.activity = !state.approve.activity
  },
  '[approve] SET_ITEM_UPDATE_IN_ORDER': (state) => {
    state.approve.in_order = !state.approve.in_order
  },
  '[approve] SET_ITEM_UPDATE_EXPIRATION_DATE': (state, value) => {
    state.approve.expiration_date = value
  },
  '[approve] SET_ITEM_UPDATE_DOCUMENT': (state, value) => {
    state.approve.document = value
  },
  '[approve] SET_ITEM_UPDATE_FILES': (state, value) => {
    state.approve.files = value
  },
  '[approve] SET_ITEM_UPDATE_COMMENT': (state, value) => {
    state.approve.comment = value
  },

  '[approve] GET_ITEM_UPDATE_TREATIES': (state, value) => {
    state.treaties = value.map(e => {
      return {
        name: `${e.id} - ${e.partner?.long_name ? e.partner.long_name + ',' : ''} ${e.project?.name}`,
        id: e.id
      }
    })
  },
  '[approve] GET_ITEM_UPDATE_USERS': (state, value) => {
    state.controlsOptions = value.map(e => {
      return {
        name: e.profile.full_name,
        id: e.id
      }
    })
  },
  '[approve] CREATE_ITEM_UPDATE_COMMENT': (state, user) => {
    const comment = state.approve.comment.trim()
    const comments = state.approve.comments
    if (comment.length > 0) {
      let newId = 0
      comments.forEach(e => {
        if (e.id >= newId) {
          newId = e.id + 1
        }
      })

      const newComment = {
        value: comment,
        name: user.profile.full_name,
        position: user?.position?.name,
        created_at: currentDateTime(),
        isControlsActive: false,
        id: newId,
        newComment: true
      }
      comments.push(newComment)
      state.approve.comment = ''
    }
  },

  '[approve] SET_ITEM_UPDATE_EDIT_COMMENT': (state, comment) => {
    state.approve.comment = comment
    state.approve.oldComment = comment
    state.approve.comments.forEach(e => {
      e.isControlsActive = false
    })
  },

  '[approve] SAVE_ITEM_UPDATE_COMMENT': (state) => {
    const comment = state.approve.comment.trim()
    const comments = state.approve.comments

    comments.forEach(elem => {
      if (elem.value === state.approve.oldComment) {
        elem.value = comment

        if (!elem.newComment) {
          state.approve.updatedComments.push(elem.id)
        }
        state.approve.comment = ''
        state.approve.oldComment = ''
      }
    })
  },

  '[approve] TOGGLE_ITEM_UPDATE_CONTROLS_COMMENT': (state, id) => {
    state.approve.comments.forEach(e => {
      e.isControlsActive = false
      if (e.id === id) {
        e.isControlsActive = true
      } else {
        e.isControlsActive = false
      }
    })
  },

  '[approve] DELETE_ITEM_UPDATE_COMMENT': (state, comment) => {
    const newArr = state.approve.comments.filter(e => { return e.id !== comment.id })
    state.approve.comments = newArr
    state.approve.comments.forEach(e => {
      e.isControlsActive = false
    })
    state.approve.oldComment = ''
    if (!comment.newComment) {
      state.approve.deletedComments.push(comment.id)
    }
  },

  '[approve] RESET_UPDATED_COMMENTS': (state) => {
    state.approve.updatedComments = []
  },
  '[approve] RESET_DELETED_COMMENTS': (state) => {
    state.approve.deletedComments = []
  },

  '[approve] OPEN_ITEM_UPDATE_CONTROL_MODAL': (state, value) => {
    const modal = state.approve.modalControl

    modal.active = true
    modal.updatedId = value

    if (value !== null) {
      const returnValue = function (object) {
        if (object.id === value) {
          return object.value
        }
      }
      modal.value = state.approve.controls.filter(returnValue)[0].value
    }
  },

  '[approve] SET_ITEM_UPDATE_CONTROL_VALUE': (state, value) => {
    state.approve.modalControl.value = value
  },

  '[approve] SAVE_ITEM_UPDATE_CONTROL': (state, data) => {
    const controls = state.approve.controls
    const controlModal = state.approve.modalControl

    if (controlModal.updatedId === null) {
      if (controlModal.value.id !== null || data?.id) {
        let newId = 0
        controls.forEach(e => {
          if (e.id >= newId) {
            newId = e.id + 1
          }
        })
        const newApprove = {
          id: newId,
          value: {
            id: data?.id || controlModal.value.id,
            name: data?.name || controlModal.value.name
          },
          isActive: false,
          isNew: true
        }

        let error
        controls.forEach(e => {
          if (e.value.id === controlModal.value.id) {
            error = true
          }
        })
        if (!error) {
          controls.push(newApprove)
        }

        controlModal.active = false
        controlModal.updatedId = null
        controlModal.value = { id: null, name: 'Не выбрано' }
      } else {
        state.validation.control.message = 'Необходимо указать сотрудника'
        state.validation.control.type = 'error'
      }
    } else {
      controls[controls.findIndex(elem => elem.id === controlModal.updatedId)].value = controlModal.value
      controlModal.active = false
      controlModal.updatedId = null
      controlModal.value = { id: null, name: 'Не выбрано' }
    }
  },
  '[approve] CLOSE_ITEM_UPDATE_CONTROL_MODAL': (state) => {
    state.approve.modalControl.active = false
    state.approve.modalControl.updatedId = null
    state.approve.modalControl.value = { id: null, name: 'Не выбрано' }
  },

  '[approve] TOGGLE_ITEM_UPDATE_CONTROL_ACTIVE_ITEM': (state, itemId) => {
    const itemsLength = state.approve.controls.length
    let counter = 0

    state.approve.controls.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.approve.isActiveDeleteControls = true : state.approve.isActiveDeleteControls = false

    state.approve.tableControlsHeader.allActive = counter === itemsLength
  },

  '[approve] TOGGLE_ITEM_UPDATE_CONTROL_ACTIVE_ALL': (state) => {
    state.approve.tableControlsHeader.allActive = !state.approve.tableControlsHeader.allActive
    state.approve.controls.forEach(e => {
      e.isActive = state.approve.tableControlsHeader.allActive
    })
    state.approve.isActiveDeleteControls = state.approve.tableControlsHeader.allActive
  },

  '[approve] DELETE_ITEM_UPDATE_CONTROL': (state) => {
    const controls = state.approve.controls

    const deletedIds = []
    controls.forEach(e => {
      if (!e.isNew && e.isActive) {
        deletedIds.push(e.id)
      }
    })
    state.approve.deletedControls = [...deletedIds]

    state.approve.controls = state.approve.controls.filter(e => { return e.isActive !== true })
    state.approve.tableControlsHeader.allActive = false
    state.approve.isActiveDeleteControls = false
  },

  '[approve] OPEN_ITEM_UPDATE_RESPONSIBLE_MODAL': (state, value) => {
    const modal = state.approve.modalResponsible

    modal.active = true
    modal.updatedId = value

    if (value !== null) {
      const returnValue = function (object) {
        if (object.id === value) {
          return object
        }
      }
      modal.value = state.approve.responsibles.filter(returnValue)[0].value
      modal.order = { id: state.approve.responsibles.filter(returnValue)[0].value.sort, name: state.approve.responsibles.filter(returnValue)[0].value.sort }
    }
  },

  '[approve] SET_ITEM_UPDATE_RESPONSIBLE_VALUE': (state, value) => {
    state.approve.modalResponsible.value = value
  },
  '[approve] SET_ITEM_UPDATE_RESPONSIBLE_ORDER': (state, value) => {
    state.approve.modalResponsible.order = value
  },

  '[approve] SAVE_ITEM_UPDATE_RESPONSIBLE': (state) => {
    const responsibles = state.approve.responsibles
    const responsibleModal = state.approve.modalResponsible

    responsibleModal.updatedVoted = false

    if (responsibleModal.updatedId === null) {
      if (responsibleModal.value.id !== null) {
        let newId = 1
        responsibles.forEach(e => {
          if (e.id >= newId) {
            newId = e.id + 1
          }
        })
        const newApprove = {
          id: newId,
          value: {
            id: responsibleModal.value.id,
            sort: responsibleModal.order.id,
            name: responsibleModal.value.name,
            voted: false,
            decision: false,
            voting_date: false
          },

          isActive: false,
          isNew: true
        }

        responsibleModal.active = false

        // проверка на наличии уже имеющегося айдишника юзера в списке
        let error
        responsibles.forEach(e => {
          if (e.value.id === responsibleModal.value.id) {
            error = true
          }
        })
        if (!error) {
          responsibles.push(newApprove)
          state.orderOptions = state.orderOptions.filter(e => e.id !== responsibleModal.order.id)
        }

        responsibleModal.updatedId = null
        responsibleModal.value = { id: null, name: 'Не выбрано' }
        responsibleModal.order = { id: null, name: 'Не выбрано' }
      } else {
        state.validation.control.message = 'Необходимо указать сотрудника'
        state.validation.control.type = 'error'
      }
    } else {
      responsibles[responsibles.findIndex(elem => elem.id === responsibleModal.updatedId)].value = responsibleModal.value
      responsibles[responsibles.findIndex(elem => elem.id === responsibleModal.updatedId)].value.sort = responsibleModal.order.id
      responsibleModal.active = false
      responsibleModal.updatedId = null
      responsibleModal.value = { id: null, name: 'Не выбрано' }
    }
  },
  '[approve] CLOSE_ITEM_UPDATE_RESPONSIBLE_MODAL': (state) => {
    state.approve.modalResponsible.active = false
    state.approve.modalResponsible.updatedId = null
    state.approve.modalResponsible.value = { id: null, name: 'Не выбрано' }
    state.approve.modalResponsible.order = null
  },

  '[approve] TOGGLE_ITEM_UPDATE_RESPONSIBLE_ACTIVE_ITEM': (state, itemId) => {
    const itemsLength = state.approve.responsibles.length
    let counter = 0

    state.approve.responsibles.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.approve.isActiveDeleteResponsibles = true : state.approve.isActiveDeleteResponsibles = false

    state.approve.tableResponsiblesHeader.allActive = counter === itemsLength
  },

  '[approve] TOGGLE_ITEM_UPDATE_RESPONSIBLE_ACTIVE_ALL': (state) => {
    state.approve.tableResponsiblesHeader.allActive = !state.approve.tableResponsiblesHeader.allActive
    state.approve.responsibles.forEach(e => {
      e.isActive = state.approve.tableResponsiblesHeader.allActive
    })
    state.approve.isActiveDeleteResponsibles = state.approve.tableResponsiblesHeader.allActive
  },

  '[approve] DELETE_ITEM_UPDATE_RESPONSIBLE': (state) => {
    const responsibles = state.approve.responsibles

    const newSortNumbers = []
    const deletedIds = []
    responsibles.forEach(e => {
      if (!e.isNew && e.isActive) {
        deletedIds.push(e.id)
      }

      if (e.isActive) {
        newSortNumbers.push({ id: e.value.sort, name: e.value.sort.toString() })
      }
    })

    state.orderOptions = state.orderOptions.concat(newSortNumbers).sort((a, b) => a.id - b.id)

    state.approve.deletedResponsibles = [...deletedIds]

    state.approve.responsibles = state.approve.responsibles.filter(e => { return e.isActive !== true })
    state.approve.tableResponsiblesHeader.allActive = false
    state.approve.isActiveDeleteResponsibles = false
  },

  '[approve] CLEAR_ITEM_UPDATE_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      case 'date':
        state.validation.date = { type: null, message: '' }
        break
      case 'control':
        state.validation.control = { type: null, message: '' }
        break
      case 'responsible':
        state.validation.responsible = { type: null, message: '' }
        break
      default:
        break
    }
  },
  '[approve] SET_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
      if (router.history.current.name !== 'ApproveUpdate_main') {
        router.push({ name: 'ApproveUpdate_main' })
      }
    }
    if (valid?.expiration_date) {
      state.validation.date.message = valid.expiration_date[0]
      state.validation.date.type = 'error'
      if (router.history.current.name !== 'ApproveUpdate_main') {
        router.push({ name: 'ApproveUpdate_main' })
      }
    }
  },

  '[approve] ENABLE_ITEM_UPDATE_EDITING': (state) => {
    state.isDisabling = false
  },

  '[approve] CHANGE_ITEM_UPDATE_RESPONSIBLE_VOTED': (state, value) => {
    state.approve.modalResponsible.updatedVoted = true
    state.approve.modalResponsible.value.voted = !value
  },
  '[approve] TOGGLE_ITEM_UPDATE_IS_LOADING': (state) => {
    state.isLoading = !state.isLoading
  }
}

const actions = {
  ...vuexFileBase.createActions(),

  async saveApproveItem ({ rootState, state, commit, dispatch }, id) {
    const data = {
      name: state.approve.name,
      document_id: state.approve.document.id,
      activity: state.approve.activity,
      in_order: state.approve.in_order,
      user_id: rootState.appData.currentUserData.id,
      expiration_date: state.approve.expiration_date,
      responsibles: createResponsibles(state.approve.responsibles),
      controls: createControls(state.approve.controls)
    }

    if (!data.responsibles) {
      return showAlertWarning('Необходимо добавить ответственных')
    }

    try {
      if (id === 'create') {
        await dispatch('createApprove', data)
      } else {
        await dispatch('updateApprove', { id, data })
      }

      await router.push({ name: 'ApproveList' })
    } catch (e) {
      showAlertError(e)
      commit('[approve] SET_ITEM_VALIDATION', e.response.data.validation)
    }

    function createResponsibles (array) {
      if (array.length > 0) {
        const newArr = []
        array.forEach((e, index) => {
          const obj = {}
          obj.user_id = e.value.id
          obj.sort = e.value?.sort ? e.value.sort : index + 1
          newArr.push(obj)
        })
        return newArr
      } else {
        return null
      }
    }

    function createControls (array) {
      if (array.length > 0) {
        const newArr = []
        array.forEach(e => {
          newArr.push(e.value.id)
        })
        return newArr
      } else {
        return null
      }
    }
  },

  async createApprove ({ dispatch, state }, data) {
    const response = await ApproveApi.create(data)
    const id = response.data.data.id

    await dispatch('processApproveComments', id)

    await dispatch('checkAndPostNewFiles', { id, data: state.approve, addExpand: false })
  },

  async updateApprove ({ state, dispatch }, { id, data }) {
    await ApproveApi.update(id, data)

    await dispatch('processApproveComments', id)
    await dispatch('checkAndDeleteFiles', id)
    await dispatch('processPostAndSortFiles', { data: state.approve, id })
  },

  async processApproveComments ({ dispatch }, id) {
    await dispatch('checkAndPostApproveComments', id)
    await dispatch('checkAndPutApproveComments', id)
    await dispatch('checkAndDeleteApproveComments', id)
  },

  async checkAndPostApproveComments ({ rootState, state }, id) {
    const newComments = state.approve?.comments?.filter(e => { return e.newComment === true })
    const data = newComments?.length ? newComments.map(comment => ({
      text: comment.value,
      user_id: rootState.appData.currentUserData.id
    })) : null

    if (!data) return

    await Promise.all(data.map(e => approveApi.postApproveComments(id, e)))
  },

  async checkAndPutApproveComments ({ state, commit }, id) {
    if (!state.approve.updatedComments.length) return

    const comments = []

    state.approve.updatedComments.forEach(e => {
      state.approve.comments.forEach(comment => {
        if (comment.id === e) {
          comments.push(comment)
        }
      })
    })

    if (!comments?.length) return

    await Promise.all(comments.map(e => approveApi.putApproveComments(id, e, e.id)))
    commit('[approve] RESET_UPDATED_COMMENTS')
  },

  async checkAndDeleteApproveComments ({ state, commit }, id) {
    if (!state.approve.deletedComments?.length) return

    await Promise.all(state.approve.deletedComments.map(e => approveApi.deleteApproveComments(id, e)))
    commit('[approve] RESET_DELETED_COMMENTS')
  },

  '[approve] getApproveItem' ({ rootState, state, commit }, id) {
    approveApi.getApproveItem(id).then(response => {
      const id = rootState.appData.currentUser.id
      commit('[approve] GET_ITEM_UPDATE', [response.data.data, id])
    })
  },

  '[approve] getTreaties' ({ state, commit }, searchValue = '') {
    const params = {
      expand: 'partner,project',
      take: 5000,
      page: 1,
      'search[all]': searchValue
    }

    if (!state.debounce) {
      commit('[approve] SET_DEBOUNCE', debounce(function () {
        axios.get(`${url}/treaties`, { params, ...config }).then(response => {
          commit('[approve] GET_ITEM_UPDATE_TREATIES', response.data.data)
        }).catch(error => {
          console.log('ошибка получения списка договоров', error)
        })

        commit('[approve] SET_DEBOUNCE', null)
      }, 500))

      state.debounce()
    }
  },
  '[approve] getUsersOptions' ({ commit }) {
    const params = {
      currentTake: 6000,
      currentPage: 1,
      searchFilter: ''
    }

    usersApi.getAll(params).then(response => {
      commit('[approve] GET_ITEM_UPDATE_USERS', response.data.data)
    }).catch(error => {
      console.log('ошибка получения юзеров', error)
    })
  },
  '[approve] createItemUpdateComment' ({ state, commit, rootState }) {
    usersApi.getCurrentUser().then(response => {
      if (state.approve.id) {
        if (state.approve.comment.trim().length > 0) {
          const commentData = {
            text: state.approve.comment,
            user_id: rootState.appData.currentUserData.id
          }
          approveApi.postApproveComments(state.approve.id, commentData).then(response => {
          })
        }
      }
      commit('[approve] CREATE_ITEM_UPDATE_COMMENT', response.data.data)
    })
  },
  '[approve] saveItemUpdateComment' ({ state, commit, rootState }) {
    if (state.approve.id) {
      if (state.approve.comment.trim().length > 0) {
        state.approve.comments.forEach(e => {
          if (e.value === state.approve.oldComment) {
            const commentData = {
              text: state.approve.comment,
              user_id: rootState.appData.currentUserData.id
            }
            approveApi.putApproveComments(state.approve.id, commentData, e.id).then(response => {
            })
          }
        })
      }
    }
    commit('[approve] SAVE_ITEM_UPDATE_COMMENT')
  },
  '[approve] pushItemUpdateToDocument' ({ state }) {
    const id = state.approve.document.id
    router.push({ name: 'ContractUpdate', params: { id } })
  },
  '[approve] getItemUpdateReport' ({ state }, value) {
    const reportData = {
      type: value,
      id: router.history.current.params.id
    }
    approveApi.getApproveReport(reportData).then(response => {
      const link = document.createElement('a')
      link.href = response.data.data
      link.click()
      link.remove()
      console.log(response)
    }).catch(error => {
      console.log('Ошибка', error.response)
    })
  },
  '[approve] decisionItemUpdate' ({ rootState }, value) {
    const params = {
      user_id: rootState.appData.currentUser.id,
      decision: value,
      voted: true
    }
    const id = router.history.current.params.id

    approveApi.voteApprove(id, params).then(response => {
      router.push({ name: 'ApproveList' })
    }).catch(error => {
      console.log('Ошибка:', error.response)
    })
  },
  '[approve] changeItemUpdateResponsibleVoted' ({ state, dispatch, commit }) {
    const id = router.history.current.params.id

    if (state.approve.modalResponsible.updatedVoted) {
      const data = {
        user_id: state.approve.modalResponsible.value.id,
        voted: state.approve.modalResponsible.value.voted,
        decision: state.approve.modalResponsible.value.decision
      }

      commit('[approve] TOGGLE_ITEM_UPDATE_IS_LOADING')

      approveApi.voteApprove(id, data).then(response => {
        dispatch('[approve] getApproveItem', id)
      }).catch(error => {
        console.log('Ошибка:', error.response)
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
